import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api';

export default function SetupPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const res = await authApi.setup({ name, email, password });
      localStorage.setItem('packliste_token', res.data.token);
      navigate('/');
    } catch (err) { setError(err.response?.data?.error || 'Fehler'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 400, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 64, marginBottom: 12 }}>✈️</div>
          <h1 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 700 }}>Packliste einrichten</h1>
        </div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Dein Name" style={inputStyle} />
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-Mail" required style={inputStyle} />
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Passwort" required style={inputStyle} />
          {error && <p style={{ color: '#f87171', fontSize: 14 }}>{error}</p>}
          <button type="submit" disabled={loading} style={{ background: '#0ea5e9', color: 'white', border: 'none', padding: '14px', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>
            {loading ? 'Erstelle...' : '🚀 Loslegen'}
          </button>
        </form>
      </div>
    </div>
  );
}
const inputStyle = { background: '#1e293b', border: '1px solid #334155', color: '#f1f5f9', padding: '12px 16px', borderRadius: 8, fontSize: 16, outline: 'none', width: '100%' };
